import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSectionNav = (id: string) => {
    setIsMenuOpen(false);
    if (isHome) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const navItems = [
    { id: 'hero', label: '首页', to: '/' },
    { id: 'categories', label: '分类浏览', to: '/#categories' },
    { id: 'featured', label: '热门推荐', to: '/#featured' },
    { id: 'latest', label: '最新更新', to: '/#latest' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group cursor-pointer">
            <div className="w-9 h-9 flex items-center justify-center">
              <i className="ri-heart-pulse-line text-2xl text-primary-500"></i>
            </div>
            <span className="text-xl font-heading text-foreground-800 whitespace-nowrap">
              奶水动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <Link
                key={item.id}
                to={item.to}
                onClick={(e) => {
                  if (isHome && item.id !== 'hero') {
                    e.preventDefault();
                    handleSectionNav(item.id);
                  }
                }}
                className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer rounded-lg hover:bg-background-100"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer rounded-lg hover:bg-background-100"
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about#contact"
              className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              联系我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="菜单"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-foreground-700`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.id}
                to={item.to}
                onClick={(e) => {
                  if (isHome && item.id !== 'hero') {
                    e.preventDefault();
                    handleSectionNav(item.id);
                  } else {
                    setIsMenuOpen(false);
                  }
                }}
                className="w-full text-left px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/about"
              className="w-full text-left px-4 py-3 text-sm text-foreground-700 hover:bg-background-100 rounded-lg transition-colors cursor-pointer whitespace-nowrap block"
              onClick={() => setIsMenuOpen(false)}
            >
              关于我们
            </Link>
            <Link
              to="/about#contact"
              className="w-full text-center px-4 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap mt-2"
              onClick={() => setIsMenuOpen(false)}
            >
              联系我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}